__turbopack_context__.v({
  "root": "range-slider-module__aH1wcq__root",
  "thumb": "range-slider-module__aH1wcq__thumb",
  "track": "range-slider-module__aH1wcq__track",
  "valueLabel": "range-slider-module__aH1wcq__valueLabel",
  "valueLabels": "range-slider-module__aH1wcq__valueLabels",
  "wrapper": "range-slider-module__aH1wcq__wrapper",
});
